import { render, staticRenderFns } from "./AreaAssetIndex.vue?vue&type=template&id=2d262419"
import script from "./AreaAssetIndex.vue?vue&type=script&lang=js"
export * from "./AreaAssetIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports